<template>
  <div v-if="!isActivePlan" class="d-flex justify-center align-center flex-column">
    <div>
      <span>A pesquisa de interesses é exclusiva para os clientes pro.</span>
    </div>
  </div>
  <div v-else>
    <v-btn
      v-if="selected.length"
      color="secondary"
      large
      fixed
      fab
      dark
      bottom
      right
      @click="copySelected()"
    >
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :loading="loading"
      show-select
      selectable-key="name"
      sort-by="name"
      :no-data-text="search ? 'Não interesses com esta pesquisa' : 'Faça a sua pesquisa :)'"
      loading-text="Pesquisando interesses..."
      :items-per-page="10000"
      class="elevation-1"
      :footer-props="{
        itemsPerPageText: 'Interesses por página:'
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Pesquisa de interesses</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            outlined
            dense
            autofocus
            hide-details
            placeholder="Pesquisa"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            style="max-width: 600px;"
          ></v-text-field>
          <v-spacer></v-spacer>
          <span v-if="items.length">{{items.length}} encontrados</span>
        </v-toolbar>
      </template>
      <template v-slot:item.path="{ item }">
        <small v-for="(path, index) in item.path" :key="index">
          {{path}} <small v-if="index < (item.path.length - 1)">></small>
        </small>
        <small class="font-italic" v-if="!item.path">Não definido</small>
      </template>
      <template v-slot:item.name="{ item }">
        <strong class="blue--text" style="cursor: pointer;" @click="copyStringToClipboard(item.name)">
          {{item.name}} <v-icon x-small>mdi-content-copy</v-icon>
        </strong>
      </template>
      <template v-slot:item.audience_size="{ item }">
        <span>{{item.audience_size | number}}</span>
      </template>
      <template v-slot:item.source="{}">
        <v-icon>mdi-facebook</v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="copied" :timeout="2000">
      Interesse(s) copiado(s) para área de transferência
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" small text v-bind="attrs" @click="copied = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import InterestSearchService from '@/services/InterestSearchService'

export default {
  data () {
    return {
      search: '',
      loading: false,
      copied: false,
      selected: [],
      items: [],
      headers: [{
        text: 'Público',
        value: 'name'
      }, {
        text: 'Tamanho',
        value: 'audience_size'
      }, {
        text: 'Interesses',
        value: 'path'
      }, {
        text: 'Origem',
        value: 'source'
      }]
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    }
  },
  watch: {
    search: function (search) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => this.index(search), 500)
    }
  },
  methods: {
    async index (q = this.search) {
      if (!q) {
        return this.items = []
      }

      this.loading = true
      this.items = await InterestSearchService.search(q)
      this.loading = false
    },
    copyStringToClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
    },
    copySelected () {
      this.copyStringToClipboard(this.selected.map(item => item.name).join(', '))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>